/**
 * 物料文档：
 * 1、【金山文档 | WPS云文档】 Saas筛选日语翻译（截止2412）https://365.kdocs.cn/l/ccDZJkTMPfW2
 * 2、【金山文档 | WPS云文档】 【日文翻译】2025新增的翻译 https://365.kdocs.cn/l/cnnHuwYtKoM9
 * 群:冯万敏邀请你加入「【国内版本】SaaS多语言处理-前端&服务端」，快点击链接加入吧 https://woa.wps.cn/invite/a2swn8j4dse?channel=stable
 * */
import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

import {
    getLang,
    LANG_TAG_ZH_CN,
    LANG_TAG_ZH_HK,
    LANG_TAG_EN_US,
    LANG_TAG_JA_JP,
    LANG_TAG_ES_MX,
    LANG_TAG_DE_DE,
    LANG_TAG_ES_ES,
    LANG_TAG_FR_CA,
    LANG_TAG_FR_FR,
    LANG_TAG_ID_ID,
    LANG_TAG_PL_PL,
    LANG_TAG_PT_BR,
    LANG_TAG_PT_PT,
    LANG_TAG_RU_RU,
    LANG_TAG_TH_TH,
    LANG_TAG_TR_TR
} from '@kdocs/i18n'
import zhCN from './zh-CN'
import enUS from './en-US'
import jaJP from './ja-JP'
import zhHK from './zh-HK'
import esMX from './es-MX'
import deDE from './de-DE'
import esES from './es-ES'
import frCA from './fr-CA'
import frFR from './fr-FR'
import idID from './id-ID'
import plPL from './pl-PL'
import ptBR from './pt-BR'
import ptPT from './pt-PT'
import ruRU from './ru-RU'
import thTH from './th-TH'
import trTR from './tr-TR'

export const defaultLang = getLang({
    langsSupported: [
        LANG_TAG_ZH_CN,
        LANG_TAG_ZH_HK,
        LANG_TAG_EN_US,
        LANG_TAG_JA_JP,
        LANG_TAG_ES_MX,
        LANG_TAG_DE_DE,
        LANG_TAG_ES_ES,
        LANG_TAG_FR_CA,
        LANG_TAG_FR_FR,
        LANG_TAG_ID_ID,
        LANG_TAG_PL_PL,
        LANG_TAG_PT_BR,
        LANG_TAG_PT_PT,
        LANG_TAG_RU_RU,
        LANG_TAG_TH_TH,
        LANG_TAG_TR_TR
    ],
})

const i18n: any = new VueI18n({
    locale: defaultLang || 'zh-CN',
    fallbackLocale: defaultLang || 'zh-CN',
    messages: {
        'zh-CN': zhCN,
        'en-US': enUS,
        'ja-JP': jaJP,
        'zh-HK': zhHK,
        'es-MX': esMX,
        'de-DE': deDE,
        'es-ES': esES,
        'fr-CA': frCA,
        'fr-FR': frFR,
        'id-ID': idID,
        'pl-PL': plPL,
        'pt-BR': ptBR,
        'pt-PT': ptPT,
        'ru-RU': ruRU,
        'th-TH': thTH,
        'tr-TR': trTR,
    },
    silentTranslationWarn: true,
})

export default i18n
